import { ReactNode, useCallback, ReactElement } from "react";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { PostalAddress } from "@evergiving/common/dist/es2015/pledge";

import { setPostalAddress } from "@/lib/redux/actions";

export function AddressPill({
  children,
  className,
  address,
  scrollIntoView,
  selected,
}: {
  children: ReactNode;
  className?: string;
  address: PostalAddress;
  scrollIntoView?: boolean;
  selected: boolean;
}): ReactElement {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(setPostalAddress(address));
  }, [dispatch, address]);

  const handleRef = useCallback((component: HTMLElement | null) => {
    if (component) {
      if (component.getBoundingClientRect().bottom > window.innerHeight) {
        component.scrollIntoView(false);
      }
    }
  }, []);

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ Discussion of this override follows:

  Keyboard events _are_ handled in the parent component, SearchAddressField.

  We force the focus to stay in the input field so that this component
  will never receive keyboard events anyway.

  jsx-a11y isn't smart enough to figure this out, so we need to
  disable the rule here.

  */

  return (
    <li
      role="option"
      className={classNames("addressChoice", className)}
      onClick={handleClick}
      ref={scrollIntoView ? handleRef : undefined}
      aria-selected={selected || undefined}
    >
      {children}
    </li>
  );

  /* eslint-enable jsx-a11y/click-events-have-key-events */
}
